/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coach_Extra_Activity_LoggingInputs */

const en_us2_coach_extra_activity_logging = /** @type {(inputs: Coach_Extra_Activity_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logging your workout…`)
};

const pt_br2_coach_extra_activity_logging = /** @type {(inputs: Coach_Extra_Activity_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrando o seu treino…`)
};

const es_419_coach_extra_activity_logging = /** @type {(inputs: Coach_Extra_Activity_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registrando tu entrenamiento…`)
};

const pt_pt2_coach_extra_activity_logging = /** @type {(inputs: Coach_Extra_Activity_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A registar o teu treino…`)
};

const fr_fr2_coach_extra_activity_logging = /** @type {(inputs: Coach_Extra_Activity_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrement de ta séance…`)
};

const de_de2_coach_extra_activity_logging = /** @type {(inputs: Coach_Extra_Activity_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Trage dein Training ein…`)
};

const it_it2_coach_extra_activity_logging = /** @type {(inputs: Coach_Extra_Activity_LoggingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Registro il tuo allenamento…`)
};

/**
* | output |
* | --- |
* | "Logging your workout…" |
*
* @param {Coach_Extra_Activity_LoggingInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const coach_extra_activity_logging = /** @type {((inputs?: Coach_Extra_Activity_LoggingInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coach_Extra_Activity_LoggingInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_coach_extra_activity_logging(inputs)
	if (locale === "es-419") return es_419_coach_extra_activity_logging(inputs)
	if (locale === "pt-PT") return pt_pt2_coach_extra_activity_logging(inputs)
	if (locale === "fr-FR") return fr_fr2_coach_extra_activity_logging(inputs)
	if (locale === "de-DE") return de_de2_coach_extra_activity_logging(inputs)
	if (locale === "it-IT") return it_it2_coach_extra_activity_logging(inputs)
	return en_us2_coach_extra_activity_logging(inputs)
});
export { coach_extra_activity_logging as "coach-extra.activity_logging" }